import { render } from "./Entries.vue?vue&type=template&id=2b096d43"
import script from "./Entries.vue?vue&type=script&lang=js"
export * from "./Entries.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__